<div class="stage-distribution-container">
  <div class="card">
    <h3 class="text-lg font-semibold mb-4 text-gray-800 dark:text-gray-100">
      Distribution par Maturité
    </h3>
    <div class="chart-wrapper" [class.loading]="loading">
      <div *ngIf="loading" class="loading-overlay">
        <p-progressSpinner ariaLabel="Loading"></p-progressSpinner>
      </div>
      <div *ngIf="chartData && !loading" class="chart-container">
        <canvas
          baseChart
          [data]="chartData"
          [options]="chartOptions"
          [type]="'bar'"
        >
        </canvas>
      </div>
      <div
        *ngIf="!chartData && !loading"
        class="no-data text-center py-8 text-gray-500"
      >
        Aucune donnée disponible
      </div>
    </div>
  </div>
</div>
